//课程直播列表功能
import request from './request'

//所有的课程列表
export function _allCourseList(data = {}) {
    const config = Object.assign(data, {
      method: 'get',
      url: '/admin/course/index',
    })
    return request(config)
}

// 所有的专题列表
export function _allTopicList(data = {}) {
  const config = Object.assign(data, {
    method: 'get',
    url: '/admin/topic/index',
  })
  return request(config)
}